import React, { memo } from 'react';
import ProfessionalPublicProfileSetup from '../components/Profile/ProfessionalPublicProfileSetup';

/**
 * Page container for the Professional Public Profile Setup
 * Component now handles its own padding/max-width for consistency
 * Using memo to prevent unnecessary re-renders
 */
const PublicProfileSetupPage = memo(() => {
  // Create a stable component key to prevent remounting
  const stableKey = 'professional-profile-setup';

  return (
    <>
      {/* Key prop ensures the component instance remains stable */}
      <ProfessionalPublicProfileSetup key={stableKey} />
    </>
  );
});

export default PublicProfileSetupPage; 